import { atom } from 'recoil';
import { PageType } from '../interfaces/AdminPage';

export const selectedPageAtom = atom({
  key: 'selectedPage',
  default: PageType.BRANDS,
});
